import React, { useCallback, useEffect, useMemo, useReducer } from "react";
import { callAPI } from "../../lib/common";
import { useAuth } from "./AuthProvider";
import { suspendResource } from "../../utils";
import SetSubjectNameDialog from "../Components/SetSubjectNameDialog";
import HasPicturesInPipelineDialog from "../Components/HasPicturesInPipelineDialog";
export const PictureSetsContext = React.createContext(null);
export const ACTION_SET_PICTURE_SETS = "setPictureSets";
export const ACTION_START_LOADING = "startLoading";
export const ACTION_STOP_LOADING = "stopLoading";
export const ACTION_SET_CURRENT_PICTURE_SET = "setCurrentPictureSet";
const pictureSetsReducer = (state, action) => {
    switch (action.type) {
        case ACTION_SET_PICTURE_SETS:
            return Object.assign(Object.assign({}, state), { isLoading: false, pictureSets: action.data });
        case ACTION_START_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case ACTION_STOP_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: false });
        case ACTION_SET_CURRENT_PICTURE_SET:
            // Fire and forget, let the server get the current:
            if (!action.pictureSet) {
                return state;
            }
            console.log("Setting current picture set in action");
            return Object.assign(Object.assign({}, state), { pictureSets: (state.pictureSets &&
                    state.pictureSets.map((ps) => {
                        var _a;
                        console.log("Mapping picture sets");
                        if (ps.subject.uuid == ((_a = action.pictureSet) === null || _a === void 0 ? void 0 : _a.subject.uuid)) {
                            return Object.assign(Object.assign({}, ps), { isCurrent: true });
                        }
                        else if (ps.isCurrent) {
                            return Object.assign(Object.assign({}, ps), { isCurrent: false });
                        }
                        return ps;
                    })) ||
                    null });
        default:
            return state;
    }
};
const initialPictureSets = suspendResource(callAPI("/ajax/user/get_picture_sets.php"));
const PictureSetsProvider = ({ children, }) => {
    console.log("Rendering picture sets");
    const iPictureSets = initialPictureSets.read();
    const [state, dispatch] = useReducer(pictureSetsReducer, {
        isLoading: false,
        pictureSets: iPictureSets.user_error ? null : iPictureSets,
    });
    const { isAuthenticated } = useAuth();
    console.log("Rendering picture sets provider", isAuthenticated, state);
    const update = () => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: ACTION_START_LOADING,
            });
            callAPI("/ajax/user/get_picture_sets.php")
                .then((pictureSets) => {
                console.log("Debug Picture sets", pictureSets);
                if (pictureSets.user_error) {
                    pictureSets = [];
                }
                // Sto before setting picture sets, in case we depend on loading:
                dispatch({
                    type: ACTION_SET_PICTURE_SETS,
                    data: pictureSets,
                });
                resolve(pictureSets);
            })
                .catch(() => {
                dispatch({
                    type: ACTION_STOP_LOADING,
                });
            });
        });
    };
    useEffect(() => {
        console.log("Auth changed", isAuthenticated, state.isLoading, state.pictureSets, isAuthenticated && !state.isLoading && state.pictureSets === null);
        // We need to load picture sets:
        if (isAuthenticated && !state.isLoading && state.pictureSets === null) {
            console.log("Rendering picture sets need update");
            update();
        }
        else if (!isAuthenticated) {
            console.log("Rendering picture sets need auth");
            dispatch({
                type: ACTION_SET_PICTURE_SETS,
                data: null,
            });
        }
    }, [isAuthenticated]);
    const setCurrentPictureSet = useCallback((pictureSet) => {
        console.log("Setting current picture set");
        callAPI("/ajax/prophoto/set_current_subject.php?uuid=" + pictureSet.subject.uuid).then((status) => {
            // Let's just ignore it for now if it failed
            if (status.error) {
                return;
            }
            dispatch({
                type: ACTION_SET_CURRENT_PICTURE_SET,
                pictureSet: pictureSet,
            });
        });
    }, []);
    const showSetNameDialog = useMemo(() => {
        const currentPictureSet = state.pictureSets !== null
            ? state.pictureSets.find((ps) => ps.isCurrent)
            : null;
        console.log("SSD: Should show dialog?", currentPictureSet, currentPictureSet === null || currentPictureSet === void 0 ? void 0 : currentPictureSet.subject.name);
        if (!currentPictureSet) {
            return null;
        }
        // If it's an autogenerated subject, the name is only numbers:
        if (currentPictureSet.subject.name.match(/^\d{4}$/)) {
            console.log("SSD: Name matches digital regexp");
            return true;
        }
        console.log("SSD: No set name dialog");
        return false;
    }, [state.pictureSets]);
    const ret = {
        isLoaded: !state.isLoading && state.pictureSets !== null,
        pictureSets: state.pictureSets,
        update,
        currentPictureSet: state.pictureSets !== null
            ? state.pictureSets.find((ps) => ps.isCurrent)
            : null,
        setCurrentPictureSet,
    };
    console.log("Show set name dialog", showSetNameDialog);
    return (React.createElement(PictureSetsContext.Provider, { value: ret },
        children,
        showSetNameDialog && React.createElement(SetSubjectNameDialog, null),
        React.createElement(HasPicturesInPipelineDialog, null)));
};
export default PictureSetsProvider;
